export const isEmailLayoutHtml = (html = "") => {
  const value = String(html || "");
  return (
    /<table[\s>]/i.test(value) ||
    /bgcolor\s*=/i.test(value) ||
    /cellspacing\s*=/i.test(value) ||
    /cellpadding\s*=/i.test(value)
  );
};

export const buildEmailPreviewHtml = (body = "") => {
  const html = String(body || "").trim();
  if (!html) return "";

  if (/<html[\s>]/i.test(html)) {
    return html;
  }

  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<link href="https://fonts.googleapis.com/css?family=Rubik:300,400,500,700|Open+Sans:300,400,600,700" rel="stylesheet" />
</head>
<body style="margin:0;padding:0;background:#f2f3f8;">
${html}
</body>
</html>`;
};
